import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromMasterTemplateNotSavedChanges from './state/master-template-not-saved-changes.reducer';
import { MasterTemplateNotSavedChangesFacade } from './state/master-template-not-saved-changes.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromMasterTemplateNotSavedChanges.MASTER_TEMPLATE_NOT_SAVED_CHANGES_FEATURE_KEY,
      fromMasterTemplateNotSavedChanges.masterTemplateNotSavedChangesReducer
    ),
  ],
  providers: [MasterTemplateNotSavedChangesFacade],
})
export class MasterTemplateNotSavedChangesModule {}
